import React from 'react';
import { useParams } from 'react-router-dom';

function Categoria(props) {
    const { categoria } = useParams();
    var categoria_actual = props.categorias?.find(c => c?.attributes?.slug === categoria);
    var subcategorias = props.categorias?.filter(c => c?.attributes?.categoria?.data?.id === categoria_actual?.id);

    if (subcategorias.length > 0) {
        var subcategorias_divs = [];
        subcategorias?.forEach(subcategoria => {
            var productos_filtrados = props.productos?.filter(p => p?.attributes?.categoria?.data?.id === subcategoria?.id);
            var productos = []

            productos_filtrados?.forEach(producto => {
                productos?.push(
                    <div className="col-6 col-md" key={producto?.id}>
                        <img className="img-fluid" src={process.env.REACT_APP_API_URL + producto?.attributes?.imagen?.data?.attributes?.url} alt={producto?.attributes?.nombre} />
                        <p className='fw-semibold text-center'>{producto?.attributes?.nombre}</p>
                    </div>
                );
            });

            const chunkArray = (myArray, chunkSize) => {
                const arrayCopy = [...myArray];
                const results = [];
                const remainder = chunkSize - (arrayCopy.length % chunkSize);
                for (let i = 0; i < remainder; i++) {
                    arrayCopy.push(<div className='col'></div>);
                }
                while (arrayCopy?.length) {
                    results.push(arrayCopy?.splice(0, chunkSize));
                }
                return results;
            };

            const productosGrupos = chunkArray(productos, 5);

            subcategorias_divs.push(
                <div className='mb-5 text-start' key={"subcategoria" + subcategoria.id}>
                    <div className="rounded mt-5 mb-3 p-2 ps-5 bg-orange text-white">{subcategoria?.attributes?.nombre}</div>
                    <div className='d-md-none'>
                        <div className='row'>
                            {productos}
                        </div>
                    </div>
                    <div className='d-none d-md-block'>
                        {productosGrupos.map((grupo, index) => (
                            <div className="row" key={index}>
                                {grupo}
                            </div>
                        ))}
                    </div>
                </div>
            )
        });
        return (
            <React.Fragment>
                <div className='container mb-5'>
                    {subcategorias_divs}
                </div>
            </React.Fragment>
        );
    }
    else {
        var productos_filtrados = props.productos?.filter(p => p?.attributes?.categoria?.data?.id === categoria_actual?.id);
        var productos = []

        productos_filtrados?.forEach(producto => {
            productos?.push(
                <div className="col-6 col-md" key={producto?.id}>
                    <img className="img-fluid" src={process.env.REACT_APP_API_URL + producto?.attributes?.imagen?.data?.attributes?.url} alt={producto?.attributes?.nombre} />
                    <p className='fw-semibold text-center'>{producto?.attributes?.nombre}</p>
                </div>
            );
        });

        const chunkArray = (myArray, chunkSize) => {
            const arrayCopy = [...myArray];
            const results = [];
            const remainder = chunkSize - (arrayCopy.length % chunkSize);
            for (let i = 0; i < remainder; i++) {
                arrayCopy.push(<div className='col'></div>);
            }
            while (arrayCopy?.length) {
                results.push(arrayCopy?.splice(0, chunkSize));
            }
            return results;
        };

        const productosGrupos = chunkArray(productos, 5);

        return (
            <React.Fragment>
                <div className='container mb-5 text-start'>
                    <div className="rounded mt-5 mb-3 p-2 ps-5 bg-orange text-white row">{categoria_actual?.attributes?.nombre}</div>
                    <div className='d-md-none'>
                        <div className='row'>
                            {productos}
                        </div>
                    </div>
                    <div className='d-none d-md-block'>
                        {productosGrupos.map((grupo, index) => (
                            <div className="row" key={index}>
                                {grupo}
                            </div>
                        ))}
                    </div>
                </div>
            </React.Fragment>
        );

    }
}

export default Categoria;
